<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="visible"
      width="62%"
      :lock-scroll="false"
      @close="$emit('update:show', false)"
      :show="show"
      class="dialog-con"
    >
      <div class="content">
        <div>
          <div>
            <p class="title">{{ appdata.title }}</p>
            <p class="text-title">{{ appdata.sub_title }}</p>
          </div>
          <ul>
            <li
              class="dis-flex lin-heig"
              v-for="(item, index) in appdata.mid_list"
              :key="index"
            >
              <div>
                <p class="vip-tit">
                  <span class="text-vip">{{ item.title.slice(0, 3) }}</span>
                  <span class="text-tit">{{ item.title.slice(3) }}</span>
                </p>
                <p>{{ item.content }}</p>
              </div>
            </li>
          </ul>
          <div class="app-text">
            <p v-html="appdata.left_bottom_content"></p>
            <!-- <p>敬请期待</p> -->
          </div>
        </div>
        <div class="app-img">
          <el-image :src="appdata.right_img_path" fit="contain" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GET_DOWNLOAD } from "@/api/mall";
export default {
  data() {
    return {
      visible: this.show,
      appdata: {}
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loadData() {
      GET_DOWNLOAD()
        .then(res => {
          this.appdata = res.data;
          console.log(res);
        })
        .catch(err => {});
    }
  },
  mounted() {
    let locale = localStorage.getItem("language");
    setTimeout(() => {
      this.$translate.setUseVersion2();
      this.$translate.language.setLocal(locale);
      this.$translate.execute();
    }, 1000);
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        this.loadData();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
  text-align: left;
  .app-text {
    padding-top: 36px;
    p {
      line-height: 35px;
      font-size: 28px;
      color: #b81d2d;
      font-weight: bold;
      &:nth-child(1) {
        padding-bottom: 12px;
      }
    }
  }
  .title {
    font-size: 36px;
    color: #000000;
    font-weight: bold;
  }
  .text-title {
    font-size: 18px;
    color: #000000;
    padding-top: 12px;
  }
  ul {
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 32px;
    li {
      width: 45%;
      padding-bottom: 32px;
      p {
        font-size: 12px;
        color: #333333;
      }
    }
    .lin-heig {
      p {
        line-height: 20px;
      }
      .vip-tit {
        padding-bottom: 10px;
        .text-vip,
        .text-tit {
          font-size: 16px;
          font-weight: bold;
        }
        .text-vip {
          color: #333333;
        }
        .text-tit {
          color: #cf2214;
        }
      }
    }
    .dis-flex {
      display: flex;
      div {
        width: 75%;
        &:nth-child(2) {
          padding-left: 60px;
        }
      }
    }
  }
}
.content ::v-deep .el-dialog {
  border-radius: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/appdialog.vue